<script>
  import Logo   from '/components/Logo'
  import Player from '/components/Player'

  export let recording = null
</script>

<style lang="scss">
  header {
    display: flex;
    justify-content: center;
    background-color: $dark;

    section {
      position: relative;
      display: flex;
      align-items: center;
      min-height: 150px;
      margin: #{4 * $GU};
      padding-left: 75px;

      &:before {
        @include dots(150px);
        bottom: calc(50% - 75px);
        left: 0;
      }

      @media (max-width: #{1024px + 8 * $GU}) {
        width: 100%;
      }

      @media (min-width: #{1024px + 8 * $GU}) {
        width: calc(1024px - 75px);
      }
    }
  }
</style>

<header>
  <section>
    {#if recording}
      <Player {recording} />
    {:else}
      <Logo />
    {/if}
  </section>
</header>
